import Image from "../components/atoms/image";
import Paragraph from "../components/atoms/paragraph";
import Button from "../components/atoms/button";
import Top from "../components/templates/top";
import Link from "../components/atoms/link";
import { SampleApp } from "../facetec/sample-app/sampleAppController";
import { useNavigate } from "react-router-dom";
import ic_selfie_blue from "../assets/icons/ic_selfie_blue.svg";
import ic_face_retouching_natural from "../assets/icons/ic_face_retouching_natural.svg";
import ic_no_sunglasses_blue from "../assets/icons/ic_no_sunglasses_blue.svg";
import listText from "../utils/dictionaries/dictionary-liveness-check";
import { useEffect, useRef, useState } from "react";
import { store } from "../redux/store";
import redCircleExclamationSharpSolid from "../assets/icons/red-circle-exclamation-sharp-solid.svg";
import ic_light_blue_phone from "../assets/icons/ic_light_blue_phone.svg";
import ic_phone_white from "../assets/icons/ic_phone_white.svg";

const LivenessCheck = () => {
  const state = store.getState();
  const navigate = useNavigate();
  const [client, setClient] = useState(false);
  const [, setSec] = useState<number>(0);
  const [toggle] = useState<boolean>(false);
  const ref = useRef<NodeJS.Timeout | null>(null);
  const [spinner, setSpinner] = useState(false);
  const [biometricValidation, setBiometricValidation] = useState<any>(null);
  const [retries, setRetries] = useState<any>();
  
  useEffect(() => {
    setClient(state.client.dataPersist.isClient);
    ref.current = setInterval(() => {
      if (toggle) setSec((state) => state + 1);
      setBiometricValidation(localStorage.getItem("biometricValidation"))
      setRetries(Number(localStorage.getItem("retries")))
    });

    return () => {
      if (ref.current) clearInterval(ref.current);
    };
  }, [toggle, biometricValidation, retries]);

  const next = () => {
    setSpinner(true);
    SampleApp.onEnrollUserPressed();

    setTimeout(() => {
      localStorage.setItem("conditionLiveness", JSON.stringify(true));
      if (client) {
        navigate("/IdentificationQuestionnaire");
      } else {
        navigate("/IdentityValidation");
      }
      setSpinner(false);
    }, 3000);
  };

  const followLaterAction = () => {
    navigate("/FollowLater", {
      state: {
        resource: "/LivenessCheck",
        step: "CONTINUE_AFTER",
        data: {}, // Agregar data del formulario
      },
    })
  };

  const end = () => {
    window.open(`tel:8008003224`, "_self");
  }

  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={listText.text_1.mainText}
          subTitle={listText.text_2.mainText}
          displayProgressBar={""}
          displayLeftImageTitle={"d-none"}
          classTitleImage={""}
          classHeader={"mt-2"}
          styleHeader={{}}
          classProgressBar={"mt-3"}
          styleProgressBar={{}}
          classTitleAndImage={""}
          styleTitleAndImage={{}}
          valueProgressBar={"80%"}
          comeFrom={"/LivenessCheck"}
          onClickGoBackIcon={() => navigate("/")}
        />
        <div className="p-3">
          <div className="text-center mb-4_3 mt-4">
            <Image
              srcImage={ic_selfie_blue}
              className={"ic_selfie_blue"}
              alt={""}
              dataBsDismiss={""}
              styleImg={undefined}
              onClick={undefined}
            ></Image>
          </div>
          {biometricValidation !== "OK" && biometricValidation !== null ?
            <>
              <div style={{ textAlign: "left", backgroundColor: "#F7F7F7" }}
                className="my-4 pt-3 rounded-2 w-100 pe-none fw-normal d-flex">
                <Image
                  srcImage={redCircleExclamationSharpSolid}
                  className="ms-2 mt-2 h-100"
                  alt={""}
                  dataBsDismiss={undefined}
                  styleImg={{ cursor: "auto" }}
                  onClick={undefined}
                />
                {
                  biometricValidation == "UNEXPECTED_ERROR" ?
                    <>
                      <Paragraph
                        text="Estamos teniendo problemas de conexión y la validación no ha podido ser realizada.  Puedes intentar de nuevo o llamar a nuestra línea de atención para te apoyemos a continuar con el trámite."
                        className="m-2"
                        styleParagraph={{
                          color: "#363A44",
                          lineHeight: "24px",
                          textDecoration: "none",
                          cursor: "auto",
                          fontSize: "16px"
                        }}
                      />
                    </>
                    :
                    <>
                      <Paragraph
                        text={retries > 2
                          ? "No pudimos completar tu validación biométrica ante el INE. Puedes contactar a nuestra línea de atención para que te apoyemos a continuar con el trámite"
                          : "La validación con el INE no fue exitosa. Puedes intentar de nuevo o llamar a nuestra línea de atención para que te apoyemos a continuar con el trámite."}
                        className="m-2"
                        styleParagraph={{
                          color: "#363A44",
                          lineHeight: "24px",
                          textDecoration: "none",
                          cursor: "auto",
                          fontSize: "16px"
                        }}
                      />
                    </>
                }

              </div>
            </>
            :
            <>
              <div className="col-12 mb-4_9">
                <Paragraph
                  text={listText.text_3.mainText}
                  className={"fs-7 mb-0 lh-base dark-blue-title"}
                  styleParagraph={undefined}
                />
              </div>
              <div className="d-flex align-items-center pb-3">
                <div className="col-1">
                  <Image
                    srcImage={ic_face_retouching_natural}
                    className={"h-32 w-32"}
                    alt={""}
                    dataBsDismiss={""}
                    styleImg={undefined}
                    onClick={undefined}
                  ></Image>
                </div>
                <div className="col-11 mt-2">
                  <Paragraph
                    text={listText.text_4.mainText}
                    className={"fs-7 mb-0 lh-base ms-3 dark-blue-title"}
                    styleParagraph={undefined}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center mb-4_3">
                <div className="col-1">
                  <Image
                    srcImage={ic_no_sunglasses_blue}
                    className={"h-32 w-32"}
                    alt={""}
                    dataBsDismiss={""}
                    styleImg={undefined}
                    onClick={undefined}
                  ></Image>
                </div>
                <div className="col-11 mt-2">
                  <Paragraph
                    text={listText.text_5.mainText}
                    className={"fs-7 mb-0 lh-base ms-3 dark-blue-title"}
                    styleParagraph={undefined}
                  />
                </div>
              </div>
            </>
          }
        </div>
      </div>
      <div className="footer--pin">
        <div className="wrapping-box-container">
          {
            biometricValidation !== "OK" && biometricValidation !== null ?
              <>
                <Button
                  text="Llamar a un Ejecutivo"
                  img={ic_light_blue_phone}
                  classNameImg=""
                  divClassName=""
                  buttonClassName={`mb-3 toggle-btn-dark-blue bg-white btn-outline-btn-dark-blue 
                  w-100 fw-semibold place-content-center align-self-center align-items-center ${retries > 2 ? "d-none" : ""}`}
                  spinner={false}
                  onClick={() => end()}
                  disabled={false}
                />
                <Button
                  text={retries > 2 ? "Llamar a línea de atención" : "Reintentar"}
                  img={retries > 2 ? ic_phone_white : ""}
                  divClassName=""
                  buttonClassName="btn-bg-primary text-white w-100 place-content-center align-self-center"
                  spinner={false}
                  onClick={retries > 2 ? () => end() : () => next()}
                  disabled={spinner}
                  dataBsDismiss={""}
                ></Button>
              </>
              :
              <div id="main-interface">
                <div id="controls">
                  <div id="vocal-icon-container" className="ft-button"></div>
                  <Button
                    id={"liveness-button"}
                    text={listText.text_6.mainText}
                    divClassName={""}
                    buttonClassName={
                      "btn-bg-primary text-white w-100 place-content-center align-self-center"
                    }
                    spinner={spinner}
                    onClick={() => next()}
                    disabled={spinner}
                    dataBsDismiss={""}
                  ></Button>
                </div>
                <div className="d-none" id="custom-logo-container" aria-hidden="true">
                  <img id="facetec-logo" src="" />
                </div>
              </div>
          }

        </div>

        <div className="text-center mt-3">
          <Link
            text={listText.text_7.mainText}
            url={null}
            styleLink={{
              color: "#5A6172",
              lineHeight: "16px",
              textDecoration: "none",
              cursor: "pointer",
            }}
            onClick={() => followLaterAction()}
            className={""}
          />
        </div>
      </div>
    </>
  );
};

export default LivenessCheck;
